const OnboardingUtils = {};

OnboardingUtils.removeOnboardingItems = () => {
  localStorage.removeItem("SaveViewContactsClicked");
  localStorage.removeItem("findProspectsClicked");
};

export default OnboardingUtils;
export { OnboardingUtils };
